import {Component, EventEmitter, Input, Output} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {TenantVerification} from "../interface/tenant-verification";
import {ToastMessageService} from "../../services/toast-message.service";
import {AuthMessageService} from "../auth-message.service";
import {
	TenantVerificationTransmissionService
} from "../../raintree/transmission/tenant-verification-transmisssion/tenant-verification-transmission.service";
import {RequestMapperService} from "../../request-mapper.service";
import {RaintreeResponse} from "../../raintree/interface/raintree-response";
import {TenantResponse} from "../../raintree/interface/tenant-response/tenant-response";
import {AuthProviderEnum} from "../enum/auth-provider-enum";

@Component({
  selector: 'fb-verify-email-form',
  templateUrl: './verify-email-form.component.html',
  styleUrls: ['./verify-email-form.component.scss']
})
export class VerifyEmailFormComponent {

	@Input()
	public emailFormControl: FormControl = new FormControl('', [
		Validators.required,
		Validators.email
	]);
	@Output()
	public authProvider: EventEmitter<AuthProviderEnum> = new EventEmitter<AuthProviderEnum>();

	public emailVerificationFormGroup: FormGroup = new FormGroup({
		email: this.emailFormControl
	});

	public tenantStatus: TenantVerification = {
		registered: false,
		emailVerified: false,
	};

	constructor(
		private _toast: ToastMessageService,
		public authMessage: AuthMessageService,
		private _tenantVerificationAPI: TenantVerificationTransmissionService
	) {
	}

	public onEmailSend(): void {
		if (this.emailFormControl.valid) {
			this._resendEmailAPI()
		}
		else {
			this.emailFormControl.markAsDirty();
		}
	}

	private _resendEmailAPI(): void {
		this._tenantVerificationAPI.sendEmail(
			RequestMapperService.SEND_EMAIL,
			{
				email: this.emailFormControl.value
			},
			() => { },
			() => { },
			(response: RaintreeResponse | TenantResponse) => {
				this._toast.success('Email sent successfully.', 'Please check your email and verify.');
			},
			(error: string) => {
			},
			() => {
			}

		)
	};

    protected readonly AuthProviderEnum = AuthProviderEnum;
}
